import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PetaniRT.css";

const PetaniRP = () => {
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [loading, setLoading] = useState(true);
  const [panens, setPanens] = useState([]);
  const [tanggal, setTanggal] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    fetchPanens();
  }, []);

  const fetchPanens = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_panen",
        { withCredentials: true }
      );
      const data = response.data;
      setPanens(data.panens || []);
      setLoading(false);

      const userResponse = await axios.get(
        "https://c-greenproject.org:7500/get_user_role",
        { withCredentials: true }
      );
      const userData = userResponse.data;
      if (!userData.error) {
        setUserInfo({
          role: userData.role,
          name: userData.name,
          full_name: userData.full_name,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Hapus Rencana Panen?",
      text: "Data ini tidak bisa dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Ya, Hapus!",
      cancelButtonText: "Batal",
      customClass: {
        popup: "rounded-4",
        confirmButton: "rounded-pill px-4",
        cancelButton: "rounded-pill px-4",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://c-greenproject.org:7500/hapus_panen?id=${id}`, { withCredentials: true })
          .then((response) => {
            Swal.fire("Sukses!", response.data.message, "success");
            fetchPanens();
          })
          .catch((error) => {
            Swal.fire(
              "Error!",
              error.response?.data?.error || "Terjadi kesalahan",
              "error"
            );
          });
      }
    });
  };

  const handleTambah = () => {
    Swal.fire({
      title: "Tambah Rencana Panen",
      html: `
        <div style="display:flex;flex-direction:column;gap:12px;text-align:left;margin-top:10px;">
          <div style="display:flex;flex-direction:column;">
            <label style="font-size:13px;font-weight:600;color:#4b5563;margin-bottom:4px;">ID Rencana Tanam</label>
            <input id="rencana_tanam_id" type="number" class="form-control" placeholder="Contoh: 12">
          </div>
          <div style="display:flex;flex-direction:column;">
            <label style="font-size:13px;font-weight:600;color:#4b5563;margin-bottom:4px;">Jumlah Estimasi Panen</label>
            <input id="jumlah_panen" type="text" inputmode="decimal" class="form-control" placeholder="Contoh: 3.8 atau 3800">
          </div>
          <div style="display:flex;flex-direction:column;">
            <label style="font-size:13px;font-weight:600;color:#4b5563;margin-bottom:4px;">Satuan Input</label>
            <select id="satuan_panen" class="form-select">
              <option value="Ton">Ton</option>
              <option value="Kg">Kg</option>
            </select>
          </div>
          <div style="display:flex;flex-direction:column;">
            <label style="font-size:13px;font-weight:600;color:#4b5563;margin-bottom:4px;">Tanggal Panen</label>
            <input id="tanggal_panen" type="date" class="form-control">
          </div>
        </div>
      `,
      confirmButtonText: "Simpan Data",
      cancelButtonText: "Batal",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      focusConfirm: false,
      customClass: {
        popup: "rounded-4",
        confirmButton: "rounded-pill px-4",
        cancelButton: "rounded-pill px-4",
      },
      didOpen: () => {
        const inputJumlah = document.getElementById("jumlah_panen");
        if (inputJumlah) {
          inputJumlah.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/,/g, ".");
          });
        }
      },
      preConfirm: () => {
        const inputTanamId = document.getElementById("rencana_tanam_id");
        const inputJumlah = document.getElementById("jumlah_panen");
        const selectSatuan = document.getElementById("satuan_panen");
        const inputTanggal = document.getElementById("tanggal_panen");

        if (!inputTanamId || !inputJumlah || !selectSatuan || !inputTanggal) {
          return false;
        }

        const rencanaTanamId = Number(inputTanamId.value);
        const rawJumlah = inputJumlah.value.trim().replace(/,/g, ".");
        const parsedJumlah = parseFloat(rawJumlah);
        const satuanPanen = selectSatuan.value;
        const tanggalPanen = inputTanggal.value;

        if (!rencanaTanamId || rencanaTanamId <= 0) {
          Swal.showValidationMessage("Rencana Tanam ID wajib diisi");
          return false;
        }
        if (!rawJumlah || isNaN(parsedJumlah) || parsedJumlah <= 0) {
          Swal.showValidationMessage("Jumlah panen harus berupa angka valid lebih dari 0");
          return false;
        }
        if (!tanggalPanen) {
          Swal.showValidationMessage("Tanggal panen wajib diisi");
          return false;
        }

        const jumlahPanenKg =
          satuanPanen === "Ton"
            ? Math.round(parsedJumlah * 1000)
            : Math.round(parsedJumlah);

        return {
          rencana_tanam_id: rencanaTanamId,
          jumlah_panen: jumlahPanenKg,
          tanggal_panen: tanggalPanen,
        };
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        axios
          .post(
            "https://c-greenproject.org:7500/add_rencana_panen",
            result.value,
            { withCredentials: true }
          )
          .then((res) => {
            Swal.fire("Berhasil", res.data.message, "success");
            fetchPanens();
          })
          .catch((err) => {
            Swal.fire(
              "Gagal",
              err.response?.data?.error || "Terjadi kesalahan",
              "error"
            );
          });
      }
    });
  };

  const handleDetail = async (id) => {
    try {
      const response = await axios.get(
        `https://c-greenproject.org:7500/view_panen_detail?id=${id}`,
        { headers: { "Cache-Control": "no-cache" }, withCredentials: true }
      );

      const panen = response.data.panens?.find((p) => String(p.id) === String(id));

      if (!panen) {
        Swal.fire("Error", "Detail tidak ditemukan.", "error");
        return;
      }

      const statusLower = String(panen.status || "").toLowerCase();
      let badgeStyle = "background:#e2e3e5;color:#41464b;border:1px solid #d3d6d8;";
      if (statusLower === "approved" || statusLower === "disetujui") {
        badgeStyle = "background:#d1e7dd;color:#0f5132;border:1px solid #badbcc;";
      } else if (statusLower === "pending" || statusLower === "menunggu") {
        badgeStyle = "background:#fff3cd;color:#664d03;border:1px solid #ffecb5;";
      } else if (statusLower === "rejected" || statusLower === "ditolak") {
        badgeStyle = "background:#f8d7da;color:#842029;border:1px solid #f5c2c7;";
      }

      const resiArray = panen["Resi pengiriman"] || panen.resi_pengiriman || [];
      const resiText =
        Array.isArray(resiArray) && resiArray.length > 0
          ? resiArray.join(", ")
          : "-";

      Swal.fire({
        title: "Detail Rencana Panen",
        width: 650,
        customClass: {
          popup: "rounded-4",
          confirmButton: "rounded-pill px-4",
        },
        html: `
          <div style="text-align:left;font-size:14px;color:#374151;">
            <div style="margin-bottom:18px;">
              <h6 style="font-size:14px;font-weight:700;color:#198754;margin-bottom:10px;border-bottom:2px solid #e5e7eb;padding-bottom:6px;">Informasi Petani</h6>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
                <div><span style="font-size:12px;color:#6b7280;display:block;">Nama Petani</span><strong>${panen.nama || "-"}</strong></div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Alamat</span><strong>${panen.alamat || "-"}</strong></div>
              </div>
            </div>

            <div style="margin-bottom:18px;">
              <h6 style="font-size:14px;font-weight:700;color:#198754;margin-bottom:10px;border-bottom:2px solid #e5e7eb;padding-bottom:6px;">Informasi Panen</h6>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
                <div><span style="font-size:12px;color:#6b7280;display:block;">Jenis Sawit</span><strong>${panen.jenis_sawit || "-"}</strong></div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Luas Lahan</span><strong>${panen.luas_lahan || "-"} Ha</strong></div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Jumlah Panen</span><strong>${panen.jumlah_panen ? Number(panen.jumlah_panen).toLocaleString("id-ID") : "-"} Kg</strong></div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Tanggal Panen</span><strong>${panen.tanggal_panen || "-"}</strong></div>
              </div>
            </div>

            <div style="margin-bottom:18px;">
              <h6 style="font-size:14px;font-weight:700;color:#198754;margin-bottom:10px;border-bottom:2px solid #e5e7eb;padding-bottom:6px;">Status & Administrasi</h6>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
                <div>
                  <span style="font-size:12px;color:#6b7280;display:block;margin-bottom:4px;">Status Validasi</span>
                  <span style="padding:4px 10px;border-radius:999px;font-size:12px;font-weight:600;display:inline-block;${badgeStyle}">${panen.status || "-"}</span>
                </div>
                <div>
                  <span style="font-size:12px;color:#6b7280;display:block;">Resi Pengiriman</span>
                  <span class="font-monospace fw-bold text-success">${resiText}</span>
                </div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Tanggal Pengajuan</span><strong>${panen.tanggal_permohonan || panen.tanggal_pengajuan || "-"}</strong></div>
                <div><span style="font-size:12px;color:#6b7280;display:block;">Tanggal Validasi</span><strong>${panen.tanggal_persetujuan || panen.tanggal_validasi || "-"}</strong></div>
              </div>
            </div>

            <div>
              <h6 style="font-size:14px;font-weight:700;color:#198754;margin-bottom:8px;border-bottom:2px solid #e5e7eb;padding-bottom:6px;">Catatan</h6>
              <div style="background:#f9fafb;padding:10px 14px;border-radius:8px;border:1px solid #e5e7eb;font-size:13px;">
                ${panen.catatan || "<span style='color:#9ca3af;font-style:italic;'>Tidak ada catatan</span>"}
              </div>
            </div>
          </div>
        `,
        confirmButtonText: "Tutup",
        confirmButtonColor: "#6c757d",
      });
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Gagal mengambil data detail.", "error");
    }
  };

  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approved" || s === "disetujui") {
      return (
        <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">
          Disetujui
        </span>
      );
    }
    if (s === "rejected" || s === "ditolak") {
      return (
        <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill border border-danger-subtle fw-semibold">
          Ditolak
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-2 rounded-pill border border-warning-subtle fw-semibold">
        Menunggu Validasi
      </span>
    );
  };

  const sortedPanens = [...panens].sort((a, b) => b.id - a.id);

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span
            className="fw-medium text-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/profile")}
          >
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">
            Portal Sistem Traceability
          </p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">
            Telsa Super Apps
          </h6>
          <p
            id="sidebar-date"
            className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2"
          >
            <img
              src="/static/schedule_11145854.png"
              alt="Date"
              style={{ width: "16px" }}
            />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petani" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/eco-home_7633847.png"
                alt="Home"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petani"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />
              Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirt" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/Tanam.png"
                alt="Planting"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanirt"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />
              Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/panen.png"
                alt="Harvest"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanirp"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />
              Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/FinalPanen.png"
                alt="Final Panen"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanifp"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />
              Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/sell_8087698.png"
                alt="Sales"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanip"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />
              Penjualan
            </div>
          </div>
        </div>

        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Rencana Panen</h2>
            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleTambah}
            >
              <i className="fa fa-plus me-2"></i>Tambah Rencana Panen
            </button>
          </div>

          <div className="divider mb-4"></div>

          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <h4 className="fw-bold text-success mb-3">Daftar Rencana Panen</h4>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data rencana panen...</p>
              </div>
            ) : sortedPanens && sortedPanens.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table
                  className="table table-hover align-middle"
                  style={{ minWidth: "900px" }}
                >
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th
                        className="text-center py-3"
                        style={{ width: "80px", borderTopLeftRadius: "10px" }}
                      >
                        ID
                      </th>
                      <th className="py-3">Nama Petani</th>
                      <th className="text-center py-3">Tanggal Panen</th>
                      <th className="py-3">Resi Pengiriman</th>
                      <th className="text-center py-3">Status</th>
                      <th
                        className="text-center py-3"
                        style={{ width: "180px", borderTopRightRadius: "10px" }}
                      >
                        Aksi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPanens.map((panen, index) => (
                      <tr key={`panen-${panen.id || index}`}>
                        <td className="text-center font-monospace fw-bold text-secondary">
                          #{panen.id}
                        </td>
                        <td className="fw-semibold text-dark text-capitalize text-nowrap">
                          {panen.nama || "-"}
                        </td>
                        <td className="text-center text-muted text-nowrap">
                          {panen.tanggal_panen || "-"}
                        </td>
                        <td className="text-nowrap">
                          {Array.isArray(panen.resi_pengiriman) &&
                          panen.resi_pengiriman.length > 0 ? (
                            <div className="d-flex flex-wrap gap-1">
                              {panen.resi_pengiriman.map((resi, idx) => (
                                <span
                                  key={idx}
                                  className="bg-light text-dark border px-2 py-1 rounded font-monospace fw-semibold"
                                  style={{ fontSize: "14px" }}
                                >
                                  {resi || "-"}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="fst-italic text-muted">-</span>
                          )}
                        </td>
                        <td className="text-center text-nowrap">
                          {getStatusBadge(panen.status)}
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-outline-info btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDetail(panen.id)}
                            >
                              Detail
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDelete(panen.id)}
                            >
                              Hapus
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i
                  className="fa fa-folder-open mb-3 opacity-50"
                  style={{ fontSize: "3rem" }}
                ></i>
                <h5 className="fw-semibold">Belum Ada Rencana Panen</h5>
                <p className="mb-0">
                  Silakan tambahkan data rencana panen baru Anda.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetaniRP;